import { SchoolInstructorDataType } from '../../../../../util/type/School/SchoolInstructorDataType';
import { SchoolDetailInstructorInputType } from '../type/Instructor/SchoolDetailInstructorNew.type';

export const schoolInstructorToInputInstructor = (instructor: SchoolInstructorDataType): SchoolDetailInstructorInputType => ({
    name: instructor.name,
    description: instructor.description,
    deletingImage: false,
    image: null
})